import React from 'react'

interface LabelValueProps {
    label?: React.ReactNode
    value: React.ReactNode
    required?: boolean
    prefix?: React.ReactNode
    suffix?: React.ReactNode
}

const LabelValue: React.FC<LabelValueProps> = ({
    label,
    value,
    required = false,
    prefix = '',
    suffix = '',
}) => {
    if (required || value) {
        if (label) {
            return (
                <>
                    {label}: {prefix}
                    <strong>
                        {Array.isArray(value) ? value.join(', ') : value}
                    </strong>
                    {suffix}
                </>
            )
        } else {
            return (
                <>
                    {prefix}
                    {value}
                    {suffix}
                </>
            )
        }
    } else {
        return null
    }
}

export default LabelValue
